import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalizeFirst', standalone: false })
export class CapitalizeFirstPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    }
  }
}
